import Link from "next/link";
import { useState } from "react";
import { acceptCookieDisclaimer } from "../../utils/DisclaimerCookie";
import styles from "./styles.module.scss";

export const Disclaimer = () => {
  const [cookiePopupAccepted, setCookiePopupAccepted] = useState(false);

  return (
    <div
      className={styles.cookie}
      data-accepted={cookiePopupAccepted}
      id="aDisclaimerCookie"
    >
      <div className={styles.disclaimer_cookie}>
        <p className={styles.text}>
          Nosso site utiliza cookies e outras tecnologias para aprimorar sua
          navegação e segurança, de acordo com os nossos{" "}
          <Link
            prefetch={false}
            href="https://finanzero.com.br/termos-e-condicoes-de-uso/"
            target="_blank"
            rel="noreferrer"
          >
            Termos de Uso
          </Link>
          . Ao continuar navegando em nosso site você concorda com essas
          condições. Veja também nossa{" "}
          <Link
            prefetch={false}
            href="https://finanzero.com.br/politica-de-privacidade-finanzero/"
            target="_blank"
            rel="noreferrer"
          >
            política de privacidade.
          </Link>
        </p>
        <button
          onClick={() => {
            acceptCookieDisclaimer();
            setCookiePopupAccepted(true);
          }}
        >
          Entendi
        </button>
      </div>
    </div>
  );
};
